import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Card,
  Divider,
  Grid,
  Typography
} from '@material-ui/core';
import {
  ShoppingPlusIcon,
  SupportIcon,
  ArticlesIcon
} from 'components/CustomSVG';
// import { createStripeAccountApi } from 'api';
import { happyfoxUrl } from 'configs';
import InfoCard from './InfoCard';
import './styles.css';


const infoContent = [
  {
    title: 'Help <br /> Articles',
    icon: <ArticlesIcon />,
    subTitle: '',
    link: happyfoxUrl,
    isExternalLink: true
  },
  {
    title: 'Need Onboarding assistance?',
    icon: <SupportIcon />,
    subTitle: 'Powered by Calendly',
    link: 'https://calendly.com/dermpro_onboarding',
    isExternalLink: true
  },
  {
    title: 'Pick Your <br /> Marketing Plan',
    icon: <ShoppingPlusIcon />,
    subTitle: '',
    link: '/marketing',
    isExternalLink: false
  }
];

const WelcomeScreen = () => {
  // const dispatch = useDispatch();
  const { profile } = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  return (
    <div className="welcome_container">
      <Typography variant="h1" component="h1" className="h1 font-medium text-36">
        Welcome to Shop Manager!
      </Typography>
      <Typography variant="h4" className="h4 font-medium mt-4">
        {'To look at your store, go to this '}
        {!!profile.stores?.length &&
          <a
            className="text-primary underline"
            href={profile.stores[0].storeUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            link
          </a>
        }
        {'.'}
      </Typography>
      <div className="flex flex-wrap w-full items-center justify-center mt-14 card_container">
        {infoContent.map((info, index) => {
          if (info.link === '/marketing' && !permissions?.marketing) {
            return null;
          }

          return (
            <InfoCard
              key={`info-card-${index}`}
              title={info.title}
              icon={info.icon}
              subTitle={info.subTitle}
              link={info.link}
              isExternalLink={info.isExternalLink}
            />
          );
        }
        )}
      </div>
      <Card elevation={25} className="mx-3 mt-14 py-5 px-8">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4" className="h4 font-semibold text-left m-0">
              Go Live Requirement Checklist
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid container>
            <Grid item xs={12} md={6}>
              {permissions?.marketing &&
              <Link
                to="/marketing"
                className="flex w-full m-3 underline custom_link"
              >
                Pick Your Marketing Plan
              </Link>}
              <Link
                to="/configurations/dns"
                className="flex w-full m-3 underline custom_link"
              >
                Connect Your Store Domain
              </Link>
              <Link
                to="/configurations/users-access"
                className="flex w-full m-3 underline custom_link"
              >
                Users Access
              </Link>
            </Grid>
            <Grid item xs={12} md={6}>
              <Link
                to="/configurations/tax-rates"
                className="flex w-full m-3 underline custom_link"
              >Tax Rates
              </Link>
              {/* {permissions?.settingsStripe &&
              <div
                onClick={() => createStripeAccountApi({dispatch})}
                className="flex w-full m-3 underline custom_link cursor-pointer"
              >
                Application for Merchant ID
              </div>} */}
              <Link
                to="/account#payments"
                className="flex w-full m-3 underline custom_link"
              >
                Payment Options
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default WelcomeScreen;
